<mat-toolbar class="stick-top">
  <mat-icon>add</mat-icon>
  Add Request
</mat-toolbar>
<div class="hbox lightly-padded button-bar">
  <button mat-raised-button class="primary" type="button" (click)="add()" [disabled]="!itsmCarrierId || !form.form.valid">
    Add
  </button>
</div>

<form #form="ngForm" role="form">
<div class="padded vbox vbox-space">
  <div *ngIf="request">
    <table class="basicTable">
      <thead>
      <tr>
        <th colspan="100">Request Detail</th>
      </tr>
      <tr>
<!--        <th>Carrier</th>-->
<!--        <th>Status</th>-->
<!--        <th>Type</th>-->
<!--        <th>Priority</th>-->
<!--        <th>Mode</th>-->
<!--        <th>Group</th>-->
<!--        <th>Level</th>-->
<!--        <th>Service Category</th>-->
        <th>Carrier</th>
        <th>Status</th>
        <th>Type</th>
        <th>Priority</th>
        <th>Urgency</th>
        <th>Mode</th>
        <th>Group</th>
        <th>Level</th>
        <th>Service Category</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td><micro-itsmCarrier-select [(itsmCarrierId)]="itsmCarrierId" [required]="true"></micro-itsmCarrier-select></td>
        <td><micro-itsmObject-select itsmObjectType="STATUS" [(value)]="request.status" [required]="true"></micro-itsmObject-select></td>
        <td><micro-itsmObject-select itsmObjectType="REQUEST_TYPE" [(value)]="request.requestType" [required]="true"></micro-itsmObject-select></td>
        <td><micro-itsmObject-select itsmObjectType="PRIORITY" [(value)]="request.priority" [required]="true"></micro-itsmObject-select></td>
        <td><micro-itsmObject-select itsmObjectType="URGENCY" [(value)]="request.urgency" [required]="true"></micro-itsmObject-select></td>
        <td><micro-itsmObject-select itsmObjectType="MODE" [(value)]="request.mode" [required]="true"></micro-itsmObject-select></td>
        <td><micro-itsmObject-select itsmObjectType="GROUP" [(value)]="request.group" [required]="true"></micro-itsmObject-select></td>
        <td><micro-itsmObject-select itsmObjectType="LEVEL" [(value)]="request.level" [required]="true"></micro-itsmObject-select></td>
        <td><micro-itsmObject-select itsmObjectType="SERVICE_CATEGORY" [(value)]="request.serviceCategory" [required]="true"></micro-itsmObject-select></td>

<!--        <td><micro-itsmCarrier-select [(itsmCarrierId)]="itsmCarrierId" [required]="true"></micro-itsmCarrier-select></td>-->
<!--        <td><micro-itsmObject-select itsmObjectType="STATUS" [(value)]="request.status" [required]="true"></micro-itsmObject-select></td>-->
<!--        <td><micro-itsmObject-select itsmObjectType="REQUEST_TYPE" [(value)]="request.requestType" [required]="true"></micro-itsmObject-select></td>-->
<!--        <td><micro-itsmObject-select itsmObjectType="PRIORITY" [(value)]="request.priority" [required]="true"></micro-itsmObject-select></td>-->
<!--        <td><micro-itsmObject-select itsmObjectType="MODE" [(value)]="request.mode" [required]="true"></micro-itsmObject-select></td>-->
<!--        <td><micro-itsmObject-select itsmObjectType="GROUP" [(value)]="request.group" [required]="true"></micro-itsmObject-select></td>-->
<!--        <td><micro-itsmObject-select itsmObjectType="LEVEL" [(value)]="request.level" [required]="true"></micro-itsmObject-select></td>-->
<!--        <td><micro-itsmObject-select itsmObjectType="SERVICE_CATEGORY" [(value)]="request.serviceCategory" [required]="true"></micro-itsmObject-select></td>-->
      </tr>
      <tr>
<!--        <th>Urgency</th>-->
<!--        <th>Category</th>-->
<!--        <th>Sub-Category</th>-->
<!--        <th>Item</th>-->
<!--        <th>Assets</th>-->
<!--        <th>Impact</th>-->
<!--        <th colspan="2">Impact Details</th>-->
        <th>Alert Source</th>
        <th>Alert Type</th>
        <th>Category</th>
        <th>Sub-Category</th>
        <th>Item</th>
        <th>Assets</th>
        <th>Impact</th>
        <th colspan="2">Impact Details</th>

      </tr>
      <tr>
<!--        <td><micro-itsmObject-select itsmObjectType="URGENCY" [(value)]="request.urgency" [required]="true"></micro-itsmObject-select></td>-->
<!--        <td><micro-itsmObject-select #categorySel itsmObjectType="CATEGORY" [(value)]="request.category" [required]="true"></micro-itsmObject-select></td>-->
<!--        <td><micro-itsmObject-select itsmObjectType="SUBCATEGORY" [(value)]="request.subCategory" [parentId]="categorySel.itsmObjectId" [required]="true"></micro-itsmObject-select></td>-->
<!--        <td><input [(ngModel)]="request.item" id="item" name="item"></td>-->
<!--        <td>-</td>-->
<!--        <td><micro-itsmObject-select itsmObjectType="IMPACT" [(value)]="request.impact" [required]="true"></micro-itsmObject-select></td>-->
<!--        <td colspan="2"><input [(ngModel)]="request.impactDetails" id="impactDetails" name="impactDetails"/></td>-->

        <td><micro-itsmObject-select itsmObjectType="ALERT_SOURCE" [(value)]="request.alertSource" [required]="true"></micro-itsmObject-select></td>
        <td><micro-itsmObject-select itsmObjectType="ALERT_TYPE" [(value)]="request.alertType" [required]="true"></micro-itsmObject-select></td>
        <td><micro-itsmObject-select #categorySel itsmObjectType="CATEGORY" [(value)]="request.category" [required]="true"></micro-itsmObject-select></td>
        <td><micro-itsmObject-select itsmObjectType="SUBCATEGORY" [(value)]="request.subCategory" [parentId]="categorySel.itsmObjectId" [required]="true"></micro-itsmObject-select></td>
        <td><input [(ngModel)]="request.item" id="item" name="item"></td>
        <td>-</td>
        <td><micro-itsmObject-select itsmObjectType="IMPACT" [(value)]="request.impact" [required]="true"></micro-itsmObject-select></td>
        <td colspan="2"><input [(ngModel)]="request.itsmImpactDetails" id="impactDetails" name="impactDetails"/></td>

      </tr>
      <tr>
        <th colspan="100">Subject</th>
      </tr>
      <tr>
        <td colspan="100">
          <input [(ngModel)]="request.subject" required id="subject" name="subject"/>
        </td>
      </tr>
      <tr>
        <th colspan="100">Description</th>
      </tr>
      <tr>
        <td colspan="100">
          <micro-rich-text [(model)]="request.description"></micro-rich-text>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
</form>
